module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/标签-置顶贴.032c8.png";